import { useInfiniteQuery } from '@tanstack/react-query'

import { axios, queryClient } from '@apps-common/lib'
import { IUnitTrafficModel } from '@apps-common/types/portal/unit'

export const QUERY_GET_UNIT_TRAFFIC_INFINITE = (identifiers?: string, startDate?: string, skip?: number, take?: number) =>
  ['getUnitTrafficInfinite', identifiers, startDate, skip, take].filter(Boolean)

export const getUnitTrafficInfinite = async (
  identifiers: string,
  skip: number,
  take: number,
  startDate?: string
): Promise<IUnitTrafficModel[]> =>
  axios
    .get(`/unit/getunittraffic?identifiers=${identifiers}&skip=${skip}&take=${take}${startDate ? `&startDate=${startDate}` : ''}`)
    .then((res) => res.data?.data)

type Props = {
  config?: any
  identifiers: string
  startDate?: string
  take: number
}

export const useGetUnitTrafficInfinite = ({ config, identifiers, startDate, take }: Props) => {
  const { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage, hasNextPage } = useInfiniteQuery({
    ...(config || {}),
    queryKey: QUERY_GET_UNIT_TRAFFIC_INFINITE(identifiers, startDate, take),
    initialPageParam: 0,
    queryFn: ({ pageParam = 0 }) => getUnitTrafficInfinite(identifiers, pageParam as number, take, startDate),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.length < take) {
        return undefined
      }

      return allPages?.reduce((acc, curr) => acc + (curr?.length || 0), 0)
    }
  })

  const refetchOverride = async () => {
    await queryClient.cancelQueries({ queryKey: QUERY_GET_UNIT_TRAFFIC_INFINITE(identifiers, startDate, take) })
    queryClient.removeQueries({ queryKey: QUERY_GET_UNIT_TRAFFIC_INFINITE(identifiers, startDate, take) })
    await queryClient.invalidateQueries({ queryKey: QUERY_GET_UNIT_TRAFFIC_INFINITE(identifiers, startDate, take) })
    refetch()
  }

  // useEffect(() => {
  //   queryClient.removeQueries({ queryKey: QUERY_GET_UNIT_TRAFFIC_INFINITE(identifiers, startDate, take) })
  // }, [])

  return { isLoading, isFetching, isRefetching, isError, data, refetch: refetchOverride, fetchNextPage, hasNextPage }
}
